 <template>
	<div class="share-preview">
		<div :class="[shadow ? 'shadow':'','sms-message']">
      <div v-if="!noedit" >
			 <img class="sms-img" :src="img" @click="launchSetOGimage" />
      </div>
      <div v-else>
        <a :href="link" target="_blank"><img class="sms-img" :src="img" /></a>
      </div>
			<div class="sms-domain">{{ domain }}</div>
			<div class="sms-title">
        <div v-if="!noedit" contenteditable @input="debounceTitle">{{ title }}</div>
        <div v-else><a target="_blank" :href="link">{{ title }}</a></div>
      </div>
			<div class="sms-description">
        <div v-if="!noedit" contenteditable @input="debounceDescription">{{ description }}</div>
        <div v-else><a target="_blank" :href="link">{{ description }}</a></div>
      </div>
		</div>
		<p v-if="!noedit" class="sms-changeimage small text-muted">Click to update the share title, description or set a different share image</p>
	  <!--<b-modal id="choose-ogimage-modal" ref="choose-ogimage-modal" size="xl" hide-footer title="Choose Share Image" body-class="pt-0">
        <sd-media-manager prefix="/sd-media/" @selectedImageFromLibrary="setDeckOgImage"></sd-media-manager>
    </b-modal>-->
    <b-modal id="crop-ogimage-modal" ref="crop-ogimage-modal" title="Choose Share Image" ok-only ok-title="Done" ok-varient="outline-primary" body-class="pt-0">
      <og-image-crop v-if="loaded" input-id="og_image" name="og_image" :image="img" @change="setDeckOgImage($event)"></og-image-crop>
    </b-modal>
	</div>
 </template>

<script>

import Noty from 'noty';
import debounce from 'debounce';

export default {
  components: {
      
  },

  props: {
    deckId: {
      type: String,
      default: '',
    },
    noedit: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: '',
    },
    shadow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      deck: null,
      body: null,
      link: null,
      img: null,
      title: null,
      description: null,
      domain: null,
      time: null,
      loaded: false,
    }
  },
  methods: {
      load: function(){
          var vm = this;
          axios.get('/deck/output/'+vm.deckId+'/settings').then(response => {
              
          		if(response.data.og_image){
          			vm.img = response.data.og_image;
          		}else{
          			vm.img = response.data.company_logo;
          		}

              //vm.img = "https://via.placeholder.com/1200x627"; // Testing

              vm.body = "Check out our SizzleDeck: <span class=\"sms-link\">"+response.data.deck_url+"</span>";

              vm.title = response.data.og_title;
              vm.description = response.data.og_description;

              vm.domain = response.data.deck_domain.toUpperCase();

              var today = new Date();
              vm.time = today.getHours() + ":" + today.getMinutes(); 

              vm.loaded = true;

          }).catch(() => {console.warn('Oh. Something went wrong. load');});
      },
      launchSetOGimage: function(){
        //this.$refs['choose-ogimage-modal'].show();
          this.$refs['crop-ogimage-modal'].show();
      },
      setDeckOgImage: function(image){

            const url = `/deck/store`;

            axios.post(url,{id:this.deckId,og_image_static:image}).then(response => {
               this.img = response.data.payload.og_image_static;


                new Noty({
                        text: 'Share image updated',
                        type: 'success',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                }).show();

            }).catch(() => console.warn('Oh. Something went wrong with setDeckOgImage'));

      },
      updateTitle: function(event){
            var title = event.target.innerText;

            const url = `/deck/store`;

            axios.post(url,{id:this.deckId,og_title:title}).then(response => {


                new Noty({
                        text: 'Share title updated',
                        type: 'success',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                }).show();

            }).catch(() => console.warn('Oh. Something went wrong with setDeckOgTitle'));

      },
      updateDescription: function(event){
        var description = event.target.innerText;

        const url = `/deck/store`;

        axios.post(url,{id:this.deckId,og_description:description}).then(response => {

                new Noty({
                        text: 'Share description updated',
                        type: 'success',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                }).show();

        }).catch(() => console.warn('Oh. Something went wrong with setDeckOgDescription'));
      },
      debounceTitle: debounce(function (e) {
        this.updateTitle(e);
      }, 1200),
      debounceDescription: debounce(function (e) {
        this.updateDescription(e);
      }, 1200)
  },
  watch: {
    value(value) {

    },
  },

  mounted() {
  	this.load();
  },

}
</script>

<style>
	.share-preview{
		position: relative;
	}
	.sms-message{
/*		position: absolute;
		border-radius: 20px;
		background: #fff;
		margin-top: 80px;
		margin-left: 40px;
		width: 70%;*/
	}
	.sms-message .sms-body{
    padding: 10px 20px;
  }
	.sms-message .sms-title{
    padding: 0px 20px 0px;
    cursor: pointer;
    min-height: 23px;
    min-width: 100%;
  }
	.sms-message .sms-domain{
		padding: 10px 20px 0px;
    font-size: 12px;
	}
  .sms-message .sms-description{
    padding: 0px 20px 10px;
    font-size: 12px;
    cursor: pointer;
    min-height: 23px;
    min-width: 100%;
  }
  .sms-body{
    font-size: 16px;
  }
  .sms-title{
    font-weight: 700;
      }
  .sms-link{
    text-decoration: underline;
  }
	.sms-message .sms-img{
		width: 100%;
    cursor: pointer;
	}
	.share-preview{
		/*height: 460px;*/
    /*height: 350px;*/
	}
	.sms-changeimage{
		position: absolute;
		bottom: -35px;
    
		right: 10px;
    right: 40px;
		/*cursor: pointer;*/
	}

  .share-preview{
    /*border: 1px solid rgba(0, 0, 0, 0.125);*/
  }
  .sms-message{
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 10px;
    
    background-color: rgba(0, 0, 0, 0.03);
  }
  .sms-img{
    border-radius: 10px 10px 0 0;
  }
  .sms-title a{
    color: #000;
    text-decoration: none;
  }
  .sms-description a{
    color: #000;
    text-decoration: none;
  }

</style>
